import qaNormal from "../static/images/sectionJobs/apply-qa-1.png";
import qaHover from "../static/images/sectionJobs/apply-qa-2.png";
import accountingNormal from "../static/images/sectionJobs/apply-accounting-1.png";
import accountingHover from "../static/images/sectionJobs/apply-accounting-2.png";
import frontendNormal from "../static/images/sectionJobs/apply-frontend-1.png";
import frontendHover from "../static/images/sectionJobs/apply-frontend-2.png";
import backendNormal from "../static/images/sectionJobs/apply-backend-1.png";
import backendHover from "../static/images/sectionJobs/apply-backend-2.png";
import pmNormal from "../static/images/sectionJobs/apply-pm-1.png";
import pmHover from "../static/images/sectionJobs/apply-pm-2.png";
import amNormal from "../static/images/sectionJobs/apply-am-1.png";
import amHover from "../static/images/sectionJobs/apply-am-2.png";
import surveycakeNormal from "../static/images/sectionJobs/apply-surveycake-1.png";
import surveycakeHover from "../static/images/sectionJobs/apply-surveycake-2.png";
import uiNormal from "../static/images/sectionJobs/apply-ui-1.png";
import uiHover from "../static/images/sectionJobs/apply-ui-2.png";
import devopsNormal from "../static/images/sectionJobs/apply-devops-1.png";
import devopsHover from "../static/images/sectionJobs/apply-devops-2.png";
import customerSuccessNormal from "../static/images/sectionJobs/apply-cs-1.png";
import customerSuccessHover from "../static/images/sectionJobs/apply-cs-2.png";
import marketingNormal from "../static/images/sectionJobs/apply-market-1.png";
import marketingHover from "../static/images/sectionJobs/apply-market-2.png";

const job = {
  Devops: "DevOps Engineer",
  Accounting: "Accounting",
  CS: "Customer Success",
  QA: "Quality Assurance Engineer",
  FE: "Front-End Developer",
  BD: "Business Development",
  PM: "Project Management",
  AM: "Account Management",
  BE: "Back-End Developer",
  UI: "UI/UX Design ",
  MKT: "Marketing",
};

export const AVAILABLE_JOBS = [
  job.BD,
  job.MKT,
  job.Devops,
  // 註解為 2025未開放職缺，當有招募時請解除註解
//   job.Accounting,
//   job.CS,
//   job.FE,
//   job.PM,
//   job.AM,
];

export const JOBS_DATA = [
  {
    position: job.BD,
    cnPosition: "無所畏懼之 SurveyCake Enterprise 商業開發實習生",
    subtitle:
      "新芽誠徵小幼苗之『 無所畏懼之 SurveyCake Business Development 商業開發實習生 』",
    imgNormal: surveycakeNormal,
    imgHover: surveycakeHover,
    intro: `我們深深相信幫助他人成功，就是幫助自己成功。<br><br>
        作為代表 SurveyCake 面對各家企業的最前線，你是每個潛在客戶的專屬顧問，並學習透過 SurveyCake 來解決企業當前所面臨的挑戰。<br><br>
        我們的客戶從財富五百強的外商到新創企業，你會接觸如行銷、客服、人資、行政等許多不同的部門。也將發現 SurveyCake 不僅是份問卷，我們要讓每個填答都為企業創造最大價值！<br><br>
        如果你喜歡與人溝通，總是能清楚表達自己的想法與耐心聆聽客戶問題並提供對應的解決方案，也對接觸各領域領導性客戶又充滿期待的話，歡迎投遞履歷！<br><br>
        `,
    needs: `
                <div>工作內容：</div>
                
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>識別、篩選潛在商機</li>
                    <li>展示介紹 SurveyCake 功能及成功案例</li>
                    <li>開立報價單、進行合約擬定作業</li>
                    <li>依客戶需求進行產品串接之溝通規劃</li>
                    <li>扮演跨部門溝通與流程優化的角色，協調、追蹤、加速專案進度</li>
                    <li>協助 BD 完成提案、企劃以及客戶管理等相關事務</li>
                </ul>
                <div>我們希望你能夠：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>企圖心，有強烈慾望達成團隊、個人目標</li>
                    <li>主動積極、自動自發，對參與新創公司充滿熱情，願意接受挑戰</li>
                    <li>能自然地與第一次見面的人建立良好關係，並能透過提供服務持續維持關係</li>
                    <li>自信樂觀，即使被拒絕也能快速釋懷、再接再厲</li>
                    <li>學習力強，能快速理解客戶需求，進而收斂以產品功能滿足其需求</li>
                    <li>誠懇且具說服力的溝通能力，出色的簡報技巧（擅長使用簡報製作工具如 Keynote、PPT）</li>
                    <li>有責任感，能夠同時身兼多項任務並耐心處理問題</li>
                 </ul>
                `,
  },
  {
    position: job.Devops,
    cnPosition: "開發維運實習工程師",
    subtitle: "新芽誠徵小幼苗之『 精益求精之 DevOps Engineer Intern 開發維運實習工程師 』",
    imgNormal: devopsNormal,
    imgHover: devopsHover,
    intro: `在這飛速成長的開發環境中，我們相當仰賴自動化的開發維運流程，提供開發者一個便捷、可靠且安全的交付成品給予組織或是客戶。透過過 DevOps 建置的持續整合、開發、測試、部署流程，可以大幅簡化人工處理的時間與錯誤，提昇開發交付的產能，幫助公司創造營收。在這個職位，你可能會需要...`,
    needs: `<div>工作內容：</div>
    <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
        <li>協助專案與產品 CI/CD 流程建置或開發</li>
        <li>協助 CI/CD 流程圖繪製</li>
        <li>協助測試流程與撰寫設定流程操作手冊</li>
        <li>與正職一起參與專案討論及流程規劃</li>
        <li>完成交辦的各項工作任務</li>
    </ul>
    <div>我們希望你能夠：</div>
    <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px">
        <li>使用 Linux 作業系統的經驗        </li>
        <li>具備網路基礎知識(DNS, TCP/IP, Firewall, Load Balancer)        </li>
        <li>良好的程式語言能力，並具有學習其他語言熱情</li>
        <li>細心、積極並且充滿活力</li>
        <li>勇於面對挑戰、不害怕挫折，且能有效率地掌控時程，完成被交付的工作任務</li>
        <li>對網路系統架構設計著迷，具有敏銳的觀察力，善於探索各種設計流程背後的原理脈絡</li>
    </ul>
    <div>如果你也符合這些條件，那就太棒了：</div>
    <ul style="padding-left: 15px; margin-top: 0;">
        <li>在校內、校外有擔任網管或相關事物的經驗</li>
        <li>學習過雲端運算管理相關課程</li>
    </ul>`,
  },
  {
    position: job.MKT,
    cnPosition: "理性與感性兼具的 UI/UX 設計實習生",
    subtitle: "新芽誠徵小幼苗之『 泰通八達之 Marketing Intern 海外行銷實習生 』",
    imgNormal: marketingNormal,
    imgHover: marketingHover,
    intro: `Following our successful $3 million Series A funding, SurveyCake is expanding into global markets, with a strong focus on Thailand and other Southeast Asian countries. We are looking for a highly motivated intern to support our marketing efforts in Thailand, playing a key role in increasing brand awareness, localizing our content, and ensuring the success of our Thai partners through a mix of paid media, owned media, and search engine optimization (SEO). <br><br></b>
            This role involves close collaboration with our local partners to help them execute effective marketing campaigns. Additionally, you will conduct market research to identify trends and opportunities, ensuring our brand strategy aligns with Thai consumer behaviors. At SurveyCake, we value data-driven decision-making, and you will have the opportunity to work on campaign analysis, gaining hands-on experience in optimizing marketing performance. <br></b>
            `,
    needs: `<div></div>
                <div>Responsibilities：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>Assist in localizing and translating marketing materials for the Thai market, ensuring they resonate with local audiences.</li>
                    <li>Support the project management of product and website localization, helping to adapt our platform to Thai users.</li>
                    <li>Work closely with Thai marketing partners, providing them with strategic guidance, marketing materials, and ongoing support to help grow their business.</li>
                    <li>Conduct in-depth market research on Thailand's digital landscape, consumer behavior, and competitor strategies to inform marketing decisions.</li>
                </ul>
                <div>Qualifications：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>Strong project management and communication skills.</li>
                    <li>Fluent in English (required); proficiency in Thai is a strong plus.</li>
                    <li>Experience working with Southeast Asian markets, especially Thailand, is preferred.</li>
                </ul>
                <div>Preferred Skills：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>Understanding of Thailand's digital marketing landscape, including social media trends, influencer marketing, and local advertising platforms (e.g., Facebook, LINE, TikTok, Google Ads).</li>
                    <li>Ability to leverage AI tools like ChatGPT to enhance marketing efficiency and content optimization.</li>
                    <li>Passion for SaaS/software products and the ability to communicate their value to businesses.</li>
                    <li>Curious and eager to learn, with a data-driven and detail-oriented mindset.</li>
                </ul>`,
  },
  {
    position: job.Accounting,
    cnPosition: "會計實習生",
    subtitle: "新芽誠徵小幼苗之『 會計實習生 』",
    imgNormal: accountingNormal,
    imgHover: accountingHover,
    intro:
      "我們在尋找一位負責與細心的會計實習生，一起成為公司的營運後盾。作為 Finance Team 的一份子，你將參與整理文件、管理固定資產，確保每一筆數據的準確性，更有機會了解到公司實務面的各種財務、稅務知識！我們期待你不僅對會計工作充滿熱情，更能以細心和精確的態度完成每一項任務！",
    needs: `
                <div>工作內容：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>整理傳票、合約及文件歸檔，協助印花稅相關事項之處理</li>
                    <li>公司固定資產、設備管理及協助設備採購事項</li>
                    <li>協助員工請款單據整理及審核</li>
                    <li>主管其他交辦事項</li>
                </ul>

                <div>希望條件：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>熟悉 Google Drive 操作</li>
                    <li>具備會計相關知識</li>
                    <li>細心謹慎，具良好溝通能力、學習能力和積極的態度</li>
                </ul>
                `,
  },
  {
    position: job.CS,
    cnPosition: "客戶成功實習生",
    subtitle: "新芽誠徵小幼苗之『 客戶成功實習生 』",
    imgNormal: customerSuccessNormal,
    imgHover: customerSuccessHover,
    intro:
      "SurveyCake Customer Success Intern 兼具熱忱與細心的客戶成功實習生為了做出更美味的問卷雞蛋糕，SurveyCake Customer Success Team 支援團隊的理念是能夠讓用戶「成功」更大於「回答」問題，我們關心用戶需求，總是以如何能夠讓用戶得到最好解決辦法為第一優先，我們需要你捲起袖子來跟我們一起製作美味蛋糕！",
    needs: `
                <div>工作內容：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>透過線上文字回覆 SurveyCake 的使用者疑問，提供使用者清楚且正確的解決方案</li>
                    <li>撰寫產品的常見問答，幫助使用者更清楚地了解 SurveyCake 產品</li>
                    <li>整理使用者回饋，幫助團隊定期了解使用者需求</li>
                    <li>與正職 CS 一同參與專案執行，例如：產品滿意度調查、電子報內容</li>
                </ul>

                <div>我們希望你能夠：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>擁有解決問題就像是在幫助朋友的熱心感</li>
                    <li>個性細心、開朗，並具備耐心和良好的 EQ</li>
                    <li>具備邏輯表達能力，能將資訊整理後有條理且清晰的表述，讓其他人理解溝通的重點</li>
                    <li>能透過文字感受到用戶情緒及需求，以恰當語言和用戶溝通</li>
                    <li>敏銳地體察使用者需求，並且主動發現問題、提供使用者最佳解決方案</li>
                    <li>對於產品新功能、網路軟體能快速上手，對新科技永遠保持好奇心</li>
                    <li>了解 SurveyCake 的客戶成功團隊工作內容，並常保熱忱的心</li>
                </ul>

                <div>如果你也符合這些條件，那就太棒了：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>擅長整理／分析數據（Excel）</li>
                    <li>擅長製作／美化簡報（PowerPoint）</li>
                    <li>CRM 軟體使用經驗：Freshdesk</li>
                </ul>
                `,
  },
  {
    position: job.QA,
    cnPosition: "測試工程師實習生",
    subtitle: "新芽誠徵小幼苗之『 測試工程師實習生 』",
    imgNormal: qaNormal,
    imgHover: qaHover,
    intro: `因應 SurveyCake scrum team 快速迭代的需求，我們在這兩年導入了 E2E test 以縮短手動測試的時間。隨著產品持續擴大，我們需要一位夥伴，負責 E2E test 的測項撰寫與修正。 在這裡你會需要與 QA、Front-End 頻繁合作。在撰寫測項的同時，依據需求請前端協助在程式碼上增加 attribute 讓自動化測試的腳本能夠正確選定這些元素。 如果你有興趣，都歡迎你向我們毛遂自薦，加入溫馨的蛋糕開發團隊。`,
    needs: `<div>工作內容：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>SurveyCake E2E 測項的撰寫/除錯</li>
                </ul>
                <div>能力需求：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px">
                   <li>熟悉 HTML/CSS/JavaScript</li> 
                   <li>不排斥學習 git 版本控制</li> 
                   <li>對自動化測試有興趣</li> 
                   <li>對程式碼維護有熱情</li> 
                </ul>
                <div>加分條件：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>對軟體測試有基本的了解</li> 
                    <li>對 Nightwatch 測試框架有基本的了解</li> 
                    <li>對 GitLab CI/CD 有興趣</li>
                </ul>`,
  },
  {
    position: job.FE,
    cnPosition: "年輕活力前端實習生",
    subtitle: "新芽誠徵小幼苗之『 年輕活力前端實習生 』",
    imgNormal: frontendNormal,
    imgHover: frontendHover,
    intro: `Think small and dream big.
        你是否願意接受挑戰，能夠專注於細節並且勇於做夢？我們不在乎你的履歷顯赫與否，只在乎你的有趣創意、工作效率、團隊合作溝通、對快速更迭網路技術的執著與熱情。新芽需要你的年輕創意與執行力，跳脫過時的框架，你將會是我們的新血，參與每一次的腦力激盪火花。只要符合以下條件，新芽團隊歡迎你加入這個與眾不同的舞台。`,
    needs: `<div>我們希望你能夠：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>熟悉 HTML5、CSS3、JavaScript、RWD</li>
                    <li>不排斥學習 Git、Webpack、ES6 與現代框架（React、Vue、Angular）</li>
                    <li>具基本視覺構成設計與版面編排美感</li>
                    <li>思緒清晰，充滿幹勁與熱情，能有效率處理各項交代事物</li>
                </ul>`,
  },
  {
    position: job.PM,
    cnPosition: "神通廣大專案管理實習生",
    subtitle: "新芽誠徵小幼苗之『 神通廣大專案管理實習生 』",
    imgNormal: pmNormal,
    imgHover: pmHover,
    intro: `在數位的領域裡，新芽 Consultant & Solution 部門專注於提供給客戶最有效的解決方案，透過友善的介面設計，以及出色的程式技術團隊，打造出優異的專案和數位產品，幫助客戶在網路世界裡奠定最穩固的基礎。我們需要你挽起袖子來跟我們一起完成各式各樣符合客戶需求且令使用者驚艷的數位專案。`,
    needs: `<div>在這個職位，你可能會需要：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>協助專案的前後台系統 QA</li> 
                    <li>協助系統的圖文內容上稿</li> 
                    <li>協助撰寫系統功能操作手冊及其他各式專案文件</li> 
                    <li>與正職 PM 一起參與專案內外部會議，並協助會議紀錄</li> 
                    <li>一起參與專案功能的討論及規劃</li> 
                    <li>完成 PM 交辦的各項工作任務</li> 
                </ul>

                <div>什麼樣的夥伴是我們正積極尋找的？</div>
                <div>我們希望你能夠：
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px">
                    <li>善於發現問題並能夠積極尋找解決方案</li> 
                    <li>有天馬行空的想法，但也有執行力能讓想法落地</li> 
                    <li>細心、積極、熱情、有創意，並且充滿活力</li> 
                    <li>勇於面對挑戰、不害怕挫折，且能有效率地掌控時程，完成被交付的任務</li> 
                    <li>喜歡跟別人溝通、樂於分享，能夠理解別人的想法並精準表達自己</li> 
                    <li>對網路科技與設計著迷，有良好的洞察力、樂於觀察生活中各種設計流程並思考背後脈絡</li> 
                    <li>不排斥學習技術知識，或對軟體開發的前後端串接方式有初步概念</li>
                </ul>
                <div>如果你也符合這些條件，那就太棒了：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>在校內或校外有規劃數位專案的經驗</li>
                    <li>曾擔任過團體中的領導角色</li>
                </ul>`,
  },
  {
    position: job.AM,
    cnPosition: "客戶管理實習生",
    subtitle: "新芽誠徵小幼苗之『 客戶管理實習生 』",
    imgNormal: amNormal,
    imgHover: amHover,
    intro: `什麼樣類型的 AM 是我們求才若渴的？<br>『熱愛挑戰、不畏失敗』可能會是你人生的座右銘。<br>喜歡腦力激盪、解決問題，你的成就感總是來自得到最佳解的瞬間。<br>不畏懼與人溝通，總是能清楚表達自己的想法與意見，甚至上台報告對你只是家常便飯。<br>對於能接觸各領域領導性客戶充滿期待。`,
    needs: `<div>工作內容：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>介紹 25sprout 及專案成功案例</li>
                    <li>有效、清楚地整理客戶需求或協助引導客戶釐清需求</li>
                    <li>協助 AM 提案規劃與製作，最佳呈現我們的解決方案</li>
                <li>協助 AM 開立報價單、進行合約擬定作業</li>
                </ul>
                <div>我們希望你能夠：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>具有高 EQ/IQ 的溝通、談判、以及處理問題的能力</li>
                    <li>具有同理心，能夠耐心聆聽客戶問題並提供對應的解決方案</li>
                    <li>積極主動、細心，協助 AM 完成提案、企劃以及客戶管理等相關事務</li>
                    <li>熱愛網路資訊與創新科技，對於新技術的誕生總是感到興奮</li>
                    <li>對網頁、APP 技術與 UI/UX 領域充滿興趣，並且有基本認知與了解</li>
                    <li>瞭解 25sprout 的業務內容，能滿懷熱忱的投入工作</li>
                    <li>良好的簡報製作能力，擅長使用 Keynote、PPT 等軟體工具</li>
                </ul>
                <div>如果你也符合這些條件，那就太棒了：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>充滿創意，周遭的人都說你鬼點子特別多</li>
                    <li>具有擔任團隊領導或社團幹部相關經驗</li>
                    <li>具備競賽、提案與企劃等相關經驗</li>
               </ul>
                `,
  },
  {
    position: job.BE,
    cnPosition: "後端實習生",
    subtitle: "新芽誠徵小幼苗之『 後端實習生 』",
    imgNormal: backendNormal,
    imgHover: backendHover,
    intro: `我們使用 Laravel 框架開發，和 DevOps 合作結合 AWS 各服務， 開發流程包含 Scrum、Git Flow、Unit / Integration test、GitLab CI/CD 並有互相 code review 和壓力測試等機制，確保程式品質穩定可靠。 目前 SurveyCake 的正職有 4 位，其他 22 位都是專案部門的工程師，彼此都會分享開發心得，多樣的經驗可以在我們內部互通是我們的一個特性。歡迎與我們一同打造最美味蛋糕的工程師加入我們的行列。`,
    needs: `<div>你將學到的經驗/技能：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>Laradock 一件安裝環境工具，可調整 docker-compose 自訂容器</li>
                    <li>GitLab CI/CD 搭配自動化 Unit / Integration Testing</li>
                    <li>VSCode 搭配 XDebug 進行開發</li>
                    <li>Git Flow 開發流程</li>
                    <li>AWS SQS / SES / S3 等技術串接</li>
                    <li>國內金流第三方服務串接</li>
                </ul>
                <div>能力需求：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px">
                    <li>熟悉 Git 基本操作：pull / add / commit / push / merge</li>
                    <li>熟悉 PHP</li>
                    <li>有使用過 Laravel 框架</li>
                    <li>具有任一資料庫使用經驗 MySQL / MariaDB</li>
                </ul>
                <div>加分條件：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>會使用 Jira、GitLab 或 GitHub</li>
                    <li>熟悉 Git 操作：rebase / revert / reset</li>
                    <li>熟悉 Unit Testing 與 Integration Testing 撰寫</li>
                    <li>相關作品或是提供 GitHub</li>
                </ul>`,
  },
  {
    position: job.UI,
    cnPosition: "理性與感性兼具的 UI/UX 設計實習生",
    subtitle: "新芽誠徵小幼苗之『 理性與感性兼具的 UI/UX 設計實習生 』",
    imgNormal: uiNormal,
    imgHover: uiHover,
    intro: `25sprout Design Team 是一個由 UI/UX 設計師組成的團隊，專注於使用者研究與數位產品設計，我們與專案管理和開發團隊密切合作，為專案創建出無限可能，並協助客戶打造兼具視覺與體驗的數位解決方案。 我們目前正在尋找一位 UI/UX Design Intern 加入，一起協力創造出令人驚豔的設計，在這裡，你將有機會接觸不同產業領域的客戶，參與完整的開發流程，深入了解需求並透過設計解決問題。`,
    needs: `<div>專業能力與個人特質是我們最重視的，希望你會是：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>熱愛數位設計，對於美學與體驗的結合有所堅持</li>
                    <li>講究設計中的每一個細節</li>
                    <li>充滿對工作的熱情，時常保持好奇心與冒險精神</li>
                    <li>喜歡團隊合作，擁有良好的溝通與表達能力</li>
                    <li>熱愛生活，除了設計以外也有不同的興趣與嗜好的一位設計師，如果你是這樣的人，25sprout 誠摯地歡迎你加入，我們將提供給你實踐想像與揮灑創意的舞台</li>
                </ul>
                <div>工作內容：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>協助專案的 UI/UX 設計執行</li>
                    <li>參與專案使用者研究相關工作</li>
                </ul>
                <div>職務需求：</div>
                <ul style="padding-left: 15px; margin-top: 0; margin-bottom: 40px;">
                    <li>擁有 UI/UX 設計經驗，對於互動介面 (Web, App) 開發流程有基本概念</li>
                    <li>了解 Figma 或數位設計相關工具的操作</li>
                    <li>具執行力且注重細節，善於溝通</li>
                    <li>對設計詞彙掌握度高，能闡述自己的設計理念</li>
                    <li>充滿好奇心與熱情，樂於接觸新事物</li>
                </ul>
                <div>加分條件，如果有的話就更讚了：</div>
                <ul style="padding-left: 15px; margin-top: 0;">
                    <li>具向量插畫設計或電腦手繪經驗</li>
                    <li>具基本 HTML5、CSS3 與 JavaScript 開發概念</li>
                </ul>`,
  }
];



// WEBPACK FOOTER //
// ./src/models/Jobs.js